var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 10,
    viewBox: "0 0 8 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.94822 0.285706H1.24986C0.937284 0.285706 0.63751 0.409876 0.416485 0.630901C0.19546 0.851926 0.0712891 1.1517 0.0712891 1.46428V9.71428H7.92843V3.26592L4.94822 0.285706ZM5.17843 1.62692L6.58722 3.03571H5.17843V1.62692ZM0.857003 8.92856V1.46428C0.857003 1.36008 0.898394 1.26016 0.972069 1.18649C1.04574 1.11281 1.14567 1.07142 1.24986 1.07142H4.39272V3.82142H7.14272V8.92856H0.857003Z",
    fill: "black",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaper);
export default __webpack_public_path__ + "static/media/Paper.17b4e2f710260db26f4e01b408da8071.svg";
export { ForwardRef as ReactComponent };